function initialState() {
    return {
        beginPosition: null,
        endPosition: null,
        beginId: '',
        endId: '',
        beginLevel: null,
        endLevel: null,
        parentOfDragged : null,
        searchPhrase: '',
        expandAll : false
    }
}

export default {
    state: initialState(),
    getters: {
        DRAG_AND_DROP_BEGIN_POSITION: state => state.beginPosition,
        DRAG_AND_DROP_END_POSITION: state => state.endPosition,
        DRAG_AND_DROP_BEGIN_ID: state => state.beginId,
        DRAG_AND_DROP_END_ID: state => state.endId,
        DRAG_AND_DROP_BEGIN_LEVEL: state => state.beginLevel,
        DRAG_AND_DROP_END_LEVEL: state => state.endLevel,
        DRAG_AND_DROP_PARENT_OF_DRAGGED: state => state.parentOfDragged,
        SEARCH_PHRASE: state => state.searchPhrase,
        EXPAND_ALL: state => state.expandAll,


    },
    mutations: {
        SET_DRAG_AND_DROP_BEGIN_POSITION(state, payload) {
            state.beginPosition = payload
        },
        SET_DRAG_AND_DROP_END_POSITION(state, payload) {
            state.endPosition = payload
        },
        SET_DRAG_AND_DROP_BEGIN_ID(state, payload) {
            state.beginId = payload;
        },
        SET_DRAG_AND_DROP_END_ID(state, payload) {
            state.endId = payload;
        },
        SET_DRAG_AND_DROP_BEGIN_LEVEL(state, payload) {
            state.beginLevel = payload;
        },
        SET_DRAG_AND_DROP_END_LEVEL(state, payload) {
            state.endLevel = payload;
        },
        SET_EXPAND_ALL(state, payload) {
            state.expandAll = payload;
        },
        SET_SEARCH_PHRASE(state, payload) {
            state.searchPhrase = payload;
        },
        SET_DRAG_AND_DROP_PARENT_OF_DRAGGED(state, payload) {
            state.parentOfDragged = payload;
        },
        RESET_DRAG_AND_DROP(state) {
            const s = initialState();
            Object.keys(s).forEach(key => {
                state[key] = s[key]
            })
        }
    },
    actions: {
        SET_DRAG_AND_DROP_BEGIN_POSITION: ({commit}, payload) => {
            commit('SET_DRAG_AND_DROP_BEGIN_POSITION', payload.beginPosition);
        },
        SET_DRAG_AND_DROP_END_POSITION: ({commit}, payload) => {
            commit('SET_DRAG_AND_DROP_END_POSITION', payload.endPosition);
        },
        SET_DRAG_AND_DROP_END_ID: ({commit}, payload) => {
            commit('SET_DRAG_AND_DROP_END_ID', payload.endId);
        },
        SET_DRAG_AND_DROP_BEGIN_ID: ({commit}, payload) => {
            commit('SET_DRAG_AND_DROP_BEGIN_ID', payload.beginId);
        },
        SET_DRAG_AND_DROP_BEGIN_LEVEL: ({commit}, payload) => {
            commit('SET_DRAG_AND_DROP_BEGIN_LEVEL', payload.beginLevel);
        },
        SET_DRAG_AND_DROP_END_LEVEL: ({commit}, payload) => {
            commit('SET_DRAG_AND_DROP_END_LEVEL', payload.endLevel);
        },
        SET_DRAG_AND_DROP_PARENT_OF_DRAGGED: ({commit}, payload) => {
            commit('SET_DRAG_AND_DROP_PARENT_OF_DRAGGED', payload.parentOfDragged);
        },
        SET_EXPAND_ALL: ({commit}, payload) => {
            commit('SET_EXPAND_ALL', payload.expandAll);
        },
        SET_SEARCH_PHRASE: ({commit}, payload) => {
            commit('SET_SEARCH_PHRASE', payload.searchPhrase);
        },
        RESET_DRAG_AND_DROP: ({commit}) => {
            commit('RESET_DRAG_AND_DROP');
        },
    }
}
